// Generated code for Big.Domain.Enums.RedenAanvraag.
// Edit _Enum.tst to change the generated output.

export enum RedenAanvraag {
    geen = 0,
    registratieArtikel3NederlandsDiploma = 1,
    registratieArtikel3AangewezenDiploma = 2,
    registratieArtikel34 = 3,
    vvAssessment = 4,
    vvFellowship = 5,
    vvSpeciaalRegime = 6,
    vvAlgemeenRegime = 7,
    vvVerkrijgenBeroepskwalificatie = 8,
    vvWaarneming = 9,
    vvRegistratieArtikel3 = 10,
    vvVoerenTitelArtikel34 = 11,
    registratieArtikel3NederlandsDiplomaVoorBig = 12,
    registratieArtikel3NederlandsDiplomaFysiotherapieVoorBig = 13,
    registratieArtikel3NederlandsDiplomaPsychotherapieVoorBig = 14,
    registratieArtikel3MetVerklaringVakbekwaamheid = 15,
    registratieArtikel34DiplomaVoorBig = 16,
    toetsenDiplomasUzi = 17,
    registratieArtikel3VerklaringVakbekwaamheidVoorBig = 18,
    registratieArtikel34VerklaringVakbekwaamheid = 19,
    vvRegistratieArtikel34 = 20,
    registratieVermelding = 21,
    herregistratieArtikel3Werkervaring = 22,
    herregistratieArtikel3Scholing = 23,
    afmeldingHerregistratie = 24,
    aanvraagPapierenFormulierHerregistratie = 25,
    aanvraagHerregistratieViaNoodprocedure = 26,
    registratieArtikel3OudNederlandsDiplomaEnPrc = 27,
    registratieArtikel3OudNederlandsDiplomaEnWerkervaring = 28,
    registratieArtikel3OudAangewezenDiplomaEnPrc = 29,
    registratieArtikel3OudAangewezenDiplomaEnWerkervaring = 30,
    registratieArtikel3ErkenningBeroepskwalificatie = 31,
    vvInhoudelijkArtikel3 = 32,
    vvInhoudelijkArtikel34 = 33,
    vvErkenningBeroepskwalificatieArtikel3 = 34,
    vvErkenningBeroepskwalificatieArtikel34 = 35,
    vvAanpassingsstage = 36,
    vvProeveVanBekwaamheid = 37,
    vvGeclausuleerdeInschrijvingBelangLandHerkomst = 38,
    vvGeclausuleerdeInschrijvingBelangSuriname = 39,
    vvGeclausuleerdeInschrijvingWezenlijkNederlandsVolksgezondheidsbelang = 40,
    vvSupervisieGelijkwaardig = 41,
    vvSupervisieNagenoegGelijkwaardig = 42,
    erkenningBasisEnSpecialistenDiploma1Loket = 43,
    vvAanvullendeOpleiding = 46,
    vvEbkVestigingInAndereLidstaatAutomatischeErkenning = 47,
    vvEbkVestigingInAndereLidstaatAlgemeenStelsel = 48,
    vvEbkTijdijdIncidDienstverInAndereLidstaatMetControleVooraf = 49,
    vvEbkTijdijdIncidDienstverInAndereLidstaatZonderControleVooraf = 50,
    vvEbkVestigingInNederlandAutomatischeErkenning = 51,
    vvEbkVestigingInNederlandAlgemeenStelsel = 52,
    vvEbkVestigingInNederlandAlgemeenStelselCompMaatr = 53,
    vvEbkTijdijdIncidDienstverInNedMetControleVooraf = 54,
    vvEbkTijdijdIncidDienstverInNedMetControleVoorafCompMaatr = 55,
    vvEbkTijdIncidDienstverInNedZonderControleVooraf = 56,
    registratieArtikel36ANederlandsDiploma = 57,
    registratieArtikel36AmetVerklaringvanVakbekwaamheid = 58,
    registratieArtikel36AmetVerklaringvanVakbekwaamheidvoorinvoeringArtikel36A = 59,
    registratieartikel36AAangewezenDiploma = 60,
    vvInhoudelijkartikel36A = 61,
    vvErkenningBeroepskwalificatieArtikel36A = 62,
    registratieArtikel3MetOudErkendBuitenlandsDiplomaEnWerkervaring = 63,
    registratieArtikel3MetOudErkendBuitenlandsDiplomaEnInNederlandBehaaldPrc = 64,
    automatischeErkenningAangewezenDiploma = 65,
    registratieArtikel3MetDeelsAutomatischeAfhandeling = 66,
    registratieArtikel36aMetDeelsAutomatischeAfhandeling = 67
}
(RedenAanvraag as any).name = 'RedenAanvraag';
